import { jsxs as _, jsx as l } from "react/jsx-runtime";
import F, { useRef as A, useMemo as X, useState as W, useContext as I, useEffect as K } from "react";
import { u as U } from "./index-6a632112.mjs";
import { Button as q } from "./button.js";
import { S as H } from "./types-b577bf77.mjs";
import { s as g, i as be, e as B, r as ee, b as L, B as te } from "./themes-5f0b3c3d.mjs";
import { InLineAlert as xe } from "./inLineAlert.js";
import { useWindowDimensions as oe } from "./useWindowDimensions.js";
import { useAccessibilityProps as Q } from "./accessibility.js";
import { ScreenReaderOnly as ve } from "./screenReaderOnly.js";
import { L as $e } from "./label-3b996c7d.mjs";
import { u as N } from "./uniqueId-321287e8.mjs";
import { ProgressBar as Se } from "./progressBar.js";
import "./lineHeights-72d3110c.mjs";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./superScript-393c70dc.mjs";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./iconButton.js";
import "./checkmarkFilled-c2b01ef1.mjs";
import "./informationFilled-05d57719.mjs";
import "./warningFilled-691cfde1.mjs";
import "./hTag-40b23797.mjs";
import "./tooltip.js";
import "./zIndices-d07533f3.mjs";
import "./getElementPosition-5026bb28.mjs";
import "./popupTip.js";
function ye({
  title: e,
  titleId: a,
  size: t,
  height: r,
  width: n,
  ...h
}) {
  const p = t ? H[t] : H.s;
  return /* @__PURE__ */ _(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: t ? p : r || p,
      width: t ? p : n || p,
      "aria-labelledby": a,
      ...h,
      children: [
        e ? /* @__PURE__ */ l("title", { id: a, children: e }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Cloud_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M7.2 34.2c0 4.32 3.06 7.92 7.2 8.82v3.6C8.28 45.72 3.6 40.5 3.6 34.2c0-7.02 5.58-12.6 12.6-12.6.72 0 1.26 0 1.8.18 2.52-4.5 7.2-7.38 12.6-7.38 5.4 0 10.08 2.88 12.78 7.02-1.26.18-2.52.54-3.78.9-1.98-2.7-5.22-4.5-8.82-4.5-3.78 0-7.02 1.98-9 4.86 1.44.72 2.88 1.8 3.96 3.06.9 1.26.18 3.06-1.44 3.06-.54 0-1.08-.36-1.44-.72-.72-.72-3.06-2.88-6.66-2.88-5.04 0-9 3.96-9 9Zm52.2 5.4c0-7.92-6.48-14.4-14.4-14.4-5.4 0-10.08 2.88-12.6 7.38-.27 0-.585-.045-.9-.09-.315-.045-.63-.09-.9-.09C23.58 32.4 18 37.98 18 45s5.58 12.6 12.6 12.6h28.8c5.04 0 9-3.96 9-9s-3.96-9-9-9ZM30.6 54c-5.04 0-9-3.96-9-9s3.96-9 9-9c3.6 0 5.94 2.16 6.66 2.88.36.36.9.72 1.44.72 1.62 0 2.34-1.8 1.44-3.06-1.08-1.26-2.52-2.34-3.96-3.06 1.98-2.88 5.22-4.86 9-4.86 5.94 0 10.8 4.86 10.8 10.8v.72c-1.8.72-3.24 2.16-4.14 3.78-.72 1.26.18 2.7 1.62 2.7.54 0 1.26-.36 1.62-.9.9-1.44 2.7-2.7 4.68-2.7 3.06 0 5.4 2.34 5.4 5.4 0 3.06-2.7 5.58-5.76 5.58H30.6Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Cloud_svg__a", children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
function Ce({
  title: e,
  titleId: a,
  size: t,
  height: r,
  width: n,
  ...h
}) {
  const p = t ? H[t] : H.s;
  return /* @__PURE__ */ _(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: t ? p : r || p,
      width: t ? p : n || p,
      "aria-labelledby": a,
      ...h,
      children: [
        e ? /* @__PURE__ */ l("title", { id: a, children: e }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Delete_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M14.4 21.6c-.9 0-1.8-.9-1.8-1.8s.9-1.8 1.8-1.8H27v-3.6c0-1.98 1.62-3.6 3.6-3.6h10.8c1.98 0 3.6 1.62 3.6 3.6V18h12.6c1.08 0 1.8.9 1.8 1.8s-.72 1.8-1.8 1.8h-2.16l-2.88 36.36c-.18 1.8-1.8 3.24-3.6 3.24H23.22c-1.8 0-3.42-1.44-3.6-3.24L16.56 21.6H14.4Zm27-7.2H30.6V18h10.8v-3.6Zm7.56 43.2H23.04l-3.06-36h31.86l-2.88 36Zm-11.16-9c0 1.08-.72 1.8-1.8 1.8s-1.8-.72-1.8-1.8v-18c0-1.08.72-1.8 1.8-1.8s1.8.72 1.8 1.8v18Zm-10.08 1.8c1.08 0 1.8-.9 1.8-1.98l-1.44-18c0-.9-.9-1.62-1.8-1.62-1.08 0-1.8.9-1.8 1.98l1.44 18c.18.9.9 1.62 1.8 1.62Zm18.36-1.62c0 .9-.9 1.62-1.8 1.62-1.08 0-1.98-.9-1.8-1.98l1.44-18c0-.9.9-1.62 1.8-1.62 1.08 0 1.8.9 1.8 1.98l-1.44 18Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Delete_svg__a", children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
function we({
  title: e,
  titleId: a,
  size: t,
  height: r,
  width: n,
  ...h
}) {
  const p = t ? H[t] : H.s;
  return /* @__PURE__ */ _(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: t ? p : r || p,
      width: t ? p : n || p,
      "aria-labelledby": a,
      ...h,
      children: [
        e ? /* @__PURE__ */ l("title", { id: a, children: e }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Undo_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M37.62 10.8c-13.68 0-24.66 11.16-24.66 24.84h-5.4l7.02 12.24 7.02-12.24h-5.04c0-11.7 9.54-21.24 21.24-21.24s21.24 9.54 21.24 21.24c0 9.72-6.66 17.82-15.48 20.34v3.6c10.98-2.52 19.08-12.42 19.08-24.12 0-13.5-11.34-24.66-25.02-24.66Z"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Undo_svg__a", children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
const Y = F.createContext({}), ut = ({ children: e }) => {
  const [a, t] = F.useState({}), r = A({}), n = A({}), h = (f, E) => {
    if (r.current) {
      if (!r.current[f])
        return;
      r.current[f](E);
    }
  }, p = (f, E) => {
    r.current && (r.current[f] || (r.current[f] = E));
  }, m = (f) => {
    if (r.current) {
      if (!r.current[f])
        return;
      r.current[f] = null, delete r.current[f];
    }
  }, v = (f, E) => {
    n.current && (n.current[f] || (n.current[f] = E));
  }, b = (f) => {
    if (n.current) {
      if (!n.current[f])
        return;
      n.current[f] = null, delete n.current[f];
    }
  }, P = (f) => {
    if (n.current)
      return n.current[f] ? n.current[f] : null;
  }, z = X(
    () => ({
      fileDispatch: h,
      fileSubscribe: p,
      fileUnsubscribe: m
    }),
    []
  ), Z = X(
    () => ({
      setFileData: v,
      getFileData: P,
      removeFileData: b
    }),
    []
  );
  return /* @__PURE__ */ l(
    Y.Provider,
    {
      value: {
        uploadStatus: a,
        setUploadStatus: t,
        fileEvent: z,
        fileData: Z
      },
      children: e
    }
  );
}, w = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  PROGRESS: "PROGRESS",
  QUEUED: "QUEUED"
}, De = [
  //images
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/svg+xml",
  //Documents
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/plain",
  //Audio
  "audio/mpeg",
  "audio/wav",
  "audio/ogg",
  "audio/x-m4a",
  //video
  "video/mp4",
  "video/quicktime",
  "video/x-msvideo",
  "video/x-matroska",
  //Archives
  "application/zip",
  "application/x-rar-compressed",
  "application/x-tar",
  "application/x-7z-compressed"
], re = () => ` 
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-start: unset;
  margin-inline-end: unset;`, Ee = U.div`
  display: flex;
  padding: unset;
  flex-direction: column;
  align-items: flex-start;
  gap: ${g["4x"]};
  width: 100%;
`, Re = U.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${g["2x"]};
`, Ue = U.p`
  ${re()}
  color: ${be.placeholder};
  font-family: ${B.medium.XS.fontFamily};
  font-size: ${B.medium.XS.fontSize};
  font-style: normal;
  font-weight: ${B.medium.XS.fontWeight};
  line-height: ${B.medium.XS.lineHeight};
`, Oe = U.div`
  box-sizing: border-box;
  display: flex;
  height: 160px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${g["2x"]};
  align-self: stretch;
  border-radius: ${ee["2x"]};
  border: ${g.px} dashed
    ${(e) => e.$disable ? e.theme.components.fileUpload.dropZoneDisableColor : e.theme.components.fileUpload.defaultDropzoneBorderColor};
  text-align: center;

  &:hover {
    border: ${(e) => e.$disable ? `${g.px} dashed ${e.theme.components.fileUpload.dropZoneDisableColor}` : `${g.px} solid ${e.theme.components.fileUpload.dropZoneBorderColor}`};
    background: ${(e) => e.$disable ? "none" : e.theme.components.fileUpload.dropZonehoverBgColor};
  }
  &:focus {
    outline: ${(e) => e.$disable ? "0" : `${L["1x"]} solid ${e.theme.components.fileUpload.dropZoneBorderColor}`};
    border: ${(e) => e.$disable ? `${L["1x"]} solid ${e.theme.components.fileUpload.dropZoneDisableColor}` : `${L["1x"]} solid ${e.theme.components.fileUpload.dropZoneBorderColor}`};
  }

  ${({ $disable: e, theme: a }) => {
  if (e)
    return `
          color: ${a.components.fileUpload.dropZoneDisableColor};
      `;
}}
`, G = U.div`
  width: 100%;
`, Fe = U.div`
  width: ${g["8x"]};
  height: ${g["8x"]};

  && > svg {
    width: ${g["8x"]};
    height: ${g["8x"]};
    fill: ${(e) => e.$disable ? e.theme.components.fileUpload.dropZoneDisableColor : e.theme.components.fileUpload.dropZoneContentColor};

    & > * {
      fill: ${(e) => e.$disable ? e.theme.components.fileUpload.dropZoneDisableColor : e.theme.components.fileUpload.dropZoneContentColor};
    }
  }
`, Be = U.p`
  ${re()}
  pointer-events: none;
  color: ${(e) => e.$disable ? e.theme.components.fileUpload.dropZoneDisableColor : e.theme.components.fileUpload.dropZoneContentColor};
  text-align: center;

  /* body/regular/XS */
  font-family: ${B.regular.XS.fontFamily};
  font-size: ${B.regular.XS.fontSize};
  font-style: normal;
  font-weight: ${B.regular.XS.fontWeight};
  line-height: ${B.regular.XS.lineHeight};

  && > span {
    color: ${(e) => e.$disable ? e.theme.components.fileUpload.dropZoneDisableColor : e.theme.components.fileUpload.dropZoneLinkColor};
    pointer-events: all;
    cursor: pointer;
  }
`, ne = ({
  helperText: e,
  className: a,
  labelProp: t,
  infoProp: r,
  trailingText: n
}) => /* @__PURE__ */ _(Re, { className: a, children: [
  /* @__PURE__ */ l(
    $e,
    {
      labelProp: {
        showRequiredIndicator: !1,
        ...t
      },
      infoProp: {
        infoText: "",
        infoType: "tooltip",
        popupTipHeader: "Info",
        ...r
      },
      trailingText: n
    }
  ),
  e && /* @__PURE__ */ l(Ue, { children: e })
] }), se = ({
  buttonLabel: e = "Choose Files To Upload",
  onClick: a,
  _disabled: t = !1,
  ariaLabelledBy: r,
  className: n,
  accessibilityOptions: h = {},
  icon: p
}) => {
  const { width: m } = oe(), v = Q("button", {
    ...h,
    ariaDisabled: t
  });
  return /* @__PURE__ */ l(
    q,
    {
      size: m > te.tabletMin ? "medium" : "small",
      variant: "outline",
      color: "primary",
      className: `btn ${n}`,
      onClick: a,
      tabIndex: 0,
      isDisabled: t,
      "aria-labelledby": r,
      leftIcon: p?.leadingIcon,
      rightIcon: p?.trailingIcon,
      ...v,
      children: e
    }
  );
}, Pe = ({
  buttonLabel: e = "Submit Files",
  onClick: a,
  _disabled: t = !1,
  ariaLabelledBy: r,
  className: n,
  accessibilityOptions: h = {},
  icon: p
}) => {
  const { width: m } = oe(), v = Q("button", {
    ...h,
    ariaDisabled: t
  });
  return /* @__PURE__ */ l(
    q,
    {
      size: m > te.tabletMin ? "medium" : "small",
      variant: "solid",
      color: "primary",
      className: `btn ${n}`,
      onClick: a,
      tabIndex: 0,
      isDisabled: t,
      "aria-labelledby": r,
      leftIcon: p?.leadingIcon,
      rightIcon: p?.trailingIcon,
      ...v,
      children: e
    }
  );
}, le = ({
  icon: e = /* @__PURE__ */ l(ye, {}),
  children: a,
  _onClick: t,
  _handleDrop: r,
  _disabled: n = !1,
  className: h,
  accessibilityOptions: p = { ariaLabel: "Browse or drag files here" }
}) => {
  const m = (b) => {
    b.preventDefault();
  }, v = Q("button", {
    ...p,
    ariaDisabled: n
  });
  return /* @__PURE__ */ _(
    Oe,
    {
      onDragOver: m,
      onDrop: (b) => !n && r && r(b),
      $disable: n,
      tabIndex: n ? -1 : 0,
      onKeyDown: (b) => {
        (b.code === "Enter" || b.code === "Space") && t && !n && t();
      },
      className: h,
      ...v,
      children: [
        /* @__PURE__ */ l(Fe, { $disable: n, children: e }),
        /* @__PURE__ */ l(
          Be,
          {
            $disable: n,
            onClick: () => t && !n && t(),
            children: a
          }
        )
      ]
    }
  );
}, V = ({
  maxFilesCount: e = 10,
  maxFileSize: a,
  allowedFileType: t,
  disabled: r = !1,
  className: n = "",
  fileUploadUrl: h,
  uploadMethod: p = "POST",
  uniqueIdentifier: m = "",
  uploadParamName: v = "file",
  children: b,
  filesHeaders: P = {},
  withCredentials: z = !1,
  alertMessages: Z = {
    invalidFile: "Please provide valid file types.",
    maxSize: "Files can be up to"
  },
  uploadStatusCallback: f
}) => {
  const E = A(null), u = A(null), [o, j] = W([]), [c, S] = W(null), { uploadStatus: y, fileEvent: O, fileData: M } = I(Y), [C, $] = W(""), [d, x] = W("");
  K(() => {
    y[m] && y[m].changeKey !== C && ($(y[m].changeKey), f && f(y[m].files));
  }, [y]), K(() => (M.setFileData(m, {
    url: h,
    method: p,
    param: v,
    headers: P,
    credentials: z
  }), () => {
    M.removeFileData(m);
  }), [
    h,
    m,
    p,
    v,
    z,
    P
  ]);
  const D = (i) => {
    const s = i - e;
    S(
      Z?.maxFileCount || `You can upload up to ${e} files. Remove ${s} file(s).`
    );
  }, ae = (i) => {
    let s = !0;
    return (t && t.length > 0 ? t.includes(i.type) : De.includes(i.type)) ? a && a * 1e3 * 1e3 < i.size && (S(
      `${Z?.maxSize || "Files can be up to"} ${a}MB.`
    ), s = !1) : (S(
      Z?.invalidFile || "Please provide valid file types."
    ), s = !1), s;
  }, ie = (i) => {
    const s = o.length;
    let R = !0;
    s > 0 && (s > e ? (D(s), R = !1) : i?.forEach((T) => {
      T && (R = ae(T));
    })), R && i?.forEach((T) => {
      T && O.fileDispatch(m, T);
    });
  };
  K(() => {
    if (ie(o), o.length) {
      const i = o.length === 1 ? `${o[0].name}  Selected` : `${o.length} files Selected`;
      x(i);
    }
    u.current?.reset();
  }, [o]);
  const ce = (i) => {
    j(
      Object.keys(i.target.files).map((s) => i.target.files[s])
    );
  }, pe = (i) => {
    i.preventDefault(), S(null), j(
      Object.keys(i.dataTransfer.files).map(
        (s) => i.dataTransfer.files[s]
      )
    );
  }, de = X(() => c ? /* @__PURE__ */ l(G, { role: "alert", children: /* @__PURE__ */ l(xe, { variant: "error", body: c }) }) : null, [c]), ue = (i, s) => F.cloneElement(i, {
    // Adding callback for file upload input change
    onClick: () => {
      E?.current?.click(), s.onClick && s.onClick();
    },
    _disabled: r
  }), me = (i, s) => F.cloneElement(i, {
    // Adding callback for file upload input change
    onClick: () => {
      s.onClick && s.onClick();
    },
    _disabled: r
  }), fe = (i, s) => F.cloneElement(i, {
    _onClick: () => {
      E?.current?.click(), s._onClick && s._onClick();
    },
    // Adding callback for file upload drop event
    _handleDrop: pe,
    _disabled: r
  }), ge = (i, s) => F.cloneElement(i, {
    helperText: s
  }), he = (i) => i?.helperText ? i?.helperText === "DEFAULT" ? `Upload up to ${e} files. ${a ? `Files can be up to ${a}MB.` : ""}` : i?.helperText : null;
  return /* @__PURE__ */ _(Ee, { className: n, children: [
    ((i) => F.Children.map(i, (s) => {
      if (s && F.isValidElement(s))
        if (s?.type === se) {
          const R = s?.props;
          return ue(s, R);
        } else if (s?.type === le) {
          const R = s?.props;
          return fe(s, R);
        } else {
          if (s?.type === G)
            return de;
          if (s?.type === ne) {
            const R = s?.props, T = he(R);
            return ge(s, T);
          } else if (s?.type === Pe) {
            const R = s?.props;
            return me(s, R);
          }
        }
      return s;
    }))(b),
    /* @__PURE__ */ l("form", { ref: u, children: /* @__PURE__ */ l(
      "input",
      {
        id: m,
        ref: E,
        type: "file",
        multiple: !0,
        hidden: !0,
        onChange: (i) => {
          ce(i), S(null);
        }
      }
    ) }),
    /* @__PURE__ */ l(ve, { "aria-live": "assertive", children: o.length && d })
  ] });
};
V.Button = se;
V.DropZone = le;
V.Alert = G;
V.Header = ne;
const Ze = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], je = (e) => {
  let a = 0, t = parseInt(e, 10) || 0;
  for (; t >= 1e3 && ++a; )
    t = t / 1e3;
  return t.toFixed(t < 10 && a > 0 ? 2 : 1) + " " + Ze[a];
}, Me = U.div`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  padding: var(--semantic-spacing-4-x, ${g["4x"]})
    var(--semantic-spacing-4-x, ${g["4x"]})
    var(--semantic-spacing-4-x, ${g["4x"]})
    var(--semantic-spacing-5-x, ${g["5x"]});
  flex-direction: column;
  align-items: flex-start;
  gap: var(--semantic-spacing-6-x, ${g["6x"]});
  flex-shrink: 0;
  border-radius: var(--semantic-radius-medium-8-px, ${ee["2x"]});
  border: ${L["1x"]} solid
    var(--semantic-color-stroke-default, #d1d5d9);
`, J = U.span`
  &.StyledIcon {
    height: ${g["6x"]};
    width: ${g["6x"]};
    padding: ${g["2x"]} 0;
    box-sizing: content-box;
    cursor: pointer;
  }
`, Te = U.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: ${g["2x"]};

  && span.StyledIcon:first-of-type {
    padding-left: ${g["2x"]};
  }
  && span.StyledIcon:last-of-type {
    padding-right: ${g["2x"]};
  }
  && svg.trash,
  && svg.retry {
    height: ${g["6x"]};
    width: ${g["6x"]};
    color: ${(e) => e.theme.components.fileUpload.progressBarIconColor};

    &[aria-disabled='true'] {
      cursor: default;
      color: ${(e) => e.theme.components.fileUpload.dropZoneDisableColor};
    }
  }
`, k = (e, a) => ({
  [a]: {
    files: Object.keys(e)?.map((t) => {
      const r = e[t];
      return r && {
        fileId: t,
        name: r.file.name,
        size: r.file.size,
        type: r.file.type,
        status: r.status,
        errorMessage: r.errorMessage,
        responseObj: r.responseObj
      };
    }).filter((t) => t !== null),
    changeKey: N()
  }
}), mt = ({
  uniqueIdentifier: e,
  className: a,
  deleteHandler: t,
  retryHandler: r
}) => {
  const { setUploadStatus: n, fileEvent: h, fileData: p } = I(Y), m = A({}), [v, b] = W({});
  K(() => (h.fileSubscribe(
    e,
    (u) => Z(u, N())
  ), () => {
    h.fileUnsubscribe(e);
  }), [e]);
  const P = (u, o, j, c, S, y, O) => {
    if (!u)
      return;
    const M = new FormData();
    M.append(S, u);
    const C = new XMLHttpRequest();
    C.open(c, j, !0), Object.keys(y).forEach(($) => {
      C.setRequestHeader($, y[$]);
    }), C.upload.onprogress = async function($) {
      const d = Math.ceil($.loaded / $.total * 100);
      await b((x) => {
        const D = {
          ...x,
          [o]: {
            ...x[o],
            progress: d,
            status: w.PROGRESS
          }
        };
        return x[o].status !== w.PROGRESS && n(k(D, e)), D;
      });
    }, C.onload = async function() {
      if (this.status >= 200 && this.status <= 299)
        await b(($) => {
          const d = {
            ...$,
            [o]: {
              ...$[o],
              progress: 100,
              errorMessage: null,
              status: w.SUCCESS,
              responseObj: this.response
            }
          };
          return n(k(d, e)), d;
        });
      else {
        let $ = "Something went wrong";
        try {
          $ = JSON.parse(this.response)?.message;
        } catch {
          console.warn("Response is not a valid json");
        }
        let d = {};
        await b((x) => {
          const D = {
            ...x,
            [o]: {
              ...x[o],
              progress: 100,
              errorMessage: $,
              status: w.ERROR,
              responseObj: this.response
            }
          };
          return d = { ...D }, setTimeout(async () => {
            await n(k(d, e));
          }, 200), D;
        });
      }
    }, C.onerror = async function($) {
      const d = "Something went wrong";
      await b((x) => {
        const D = {
          ...x,
          [o]: {
            ...x[o],
            progress: 100,
            errorMessage: d,
            status: w.ERROR,
            responseObj: this.response
          }
        };
        return n(k(D, e)), D;
      });
    }, C.ontimeout = async function($) {
      const d = "Request timed out!";
      await b((x) => {
        const D = {
          ...x,
          [o]: {
            ...x[o],
            progress: 100,
            errorMessage: d,
            status: w.ERROR,
            responseObj: this.response
          }
        };
        return n(k(D, e)), D;
      });
    }, C.withCredentials = O, C.send(M);
  }, z = (u) => {
    if (!v[u]?.file)
      return;
    const o = p.getFileData(e);
    P(
      v[u].file,
      u,
      o.url,
      o.method,
      o.param,
      o.headers,
      o.credentials
    );
  }, Z = async (u, o) => {
    u && async function(c) {
      await b((y) => {
        const O = {
          ...y,
          [c]: {
            file: u,
            progress: 0,
            status: w.QUEUED,
            errorMessage: null
          }
        };
        return n(k(O, e)), O;
      });
      const S = p.getFileData(e);
      P(
        u,
        c,
        S.url,
        S.method,
        S.param,
        S.headers,
        S.credentials
      );
    }(o);
  }, f = async (u) => {
    if (!u)
      return;
    const o = { ...v };
    o[u] && (o[u] = null, delete o[u]), m.current && m.current[u] && m.current[u] && (m.current[u] = null, delete m.current[u]), await b(o), n(k(o, e));
  }, E = X(() => Object.keys(v)?.map(
    (o, j) => {
      if (!o)
        return null;
      const c = v[o];
      if (!c)
        return null;
      const S = `${c.file.name || ""} (${je(
        c.file.size
      )})`, y = c.status === w.SUCCESS ? "success" : c.status === w.ERROR ? "error" : "default", O = y === "error" ? c.errorMessage : "", M = () => {
        if (m.current) {
          let d = m.current[o];
          const x = `${c.progress}_${y}_${c.errorMessage}`;
          return (!d || d && d.compareKey !== x) && (d = {
            compareKey: x,
            progressBar: /* @__PURE__ */ l(
              Se,
              {
                accessibilityOptions: {
                  ariaValuText: c.status === "default" ? "progressing" : c.status,
                  ariaValuenow: c.progress,
                  ariaBusy: !["success", "error"].includes(c.status)
                },
                labelProp: {
                  label: S
                },
                maxValue: 100,
                progressValue: c.progress,
                status: y,
                helperText: O,
                trailingText: c.status === w.QUEUED ? "Queued" : c.status === w.PROGRESS ? `${c.progress}%` : ""
              },
              N()
            )
          }, m.current[o] = d), d.progressBar;
        }
      }, C = c.status !== w.SUCCESS && c.status !== w.ERROR, $ = c.status === w.ERROR;
      return /* @__PURE__ */ _(Te, { children: [
        M(),
        $ && /* @__PURE__ */ l(
          J,
          {
            className: "StyledIcon",
            onClick: (d) => {
              z(o), r && r(d, { ...c, fileId: o });
            },
            children: /* @__PURE__ */ l(we, { className: "retry" })
          }
        ),
        /* @__PURE__ */ l(J, { className: "StyledIcon", children: /* @__PURE__ */ l(
          Ce,
          {
            role: "button",
            "aria-disabled": C,
            "aria-label": "trash",
            tabIndex: C ? -1 : 0,
            className: "trash",
            onKeyDown: (d) => {
              (d.code === "Enter" || d.code === "Space") && (C || (f(o), t && t(d, { ...c, fileId: o })));
            },
            onClick: (d) => {
              f(o), t && t(d, { ...c, fileId: o });
            }
          }
        ) })
      ] }, j);
    }
  ), [v]);
  return E.length > 0 ? /* @__PURE__ */ l(
    Me,
    {
      className: a,
      "aria-label": `${e}-progress-bar`,
      children: E.map((u) => u)
    }
  ) : null;
};
export {
  mt as FileProgress,
  V as FileUpload,
  ut as FileUploadProvider,
  w as UPLOAD_STATUS
};
